import type { IRewardsOverview } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import { DefaultFetchService } from "app/services/fetchService";

const fetchService = DefaultFetchService.getInstance();

export interface IRewardsOverviewResponse {
    Result: IRewardsOverview;
}

export const rewardsOverviewApi = async (): Promise<IRewardsOverviewResponse> =>
    fetchService.get("/api/homepage/invitations/rewards/overview", null, { numberOfRetry: 2 });
